export default __webpack_public_path__ + "static/media/new_dashboard_healthrecord_icon.b6555b1f.svg";